import React from 'react'
//import { FormattedMessage } from 'react-intl'
import { isNull } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, branch, renderComponent } from 'recompose'
import InnerHTML from 'script-inner-html'
import { get } from '../store/reducers/checkout'
import { fetchingState } from '../helpers/hocs.js'

import NotFound from './404'

const StaticPage = ({ checkout }) => {
  if (!checkout) return null
  const html = checkout.exec
  return (
    <div className='Container Container_top-negative'>
      <div className='Main Main_privacy'>
        <InnerHTML html={html} />
      </div>
      {/*  <div className='Home__more'>
         <a href={checkout.url} className='Button Button_black'>
          <FormattedMessage id='profile_sidebar.pay_button' />
        </a>
      </div>*/}
    </div>
  )
}

const mapStateToProps = ({ checkout }) => ({ ...checkout })

const mapDispatchToProps = dispatch => bindActionCreators({ get }, dispatch)
const mergeProps = (state, { get }, { id, fetchingWrap, on404, ...props }) => ({
  ...state,
  ...props,
  id,
  get: async (newId, noLoader = true) => {
    id = newId || id
    if (!id) return
    const result = noLoader ? await get(id) : await fetchingWrap(get.bind(this, id))
    if (result !== 200 && result !== 301) on404()
  }
})


export default compose(
  branch(({ id }) => !id, renderComponent(NotFound)),
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    componentWillMount () {
      if (!this.props.data) this.props.get()
    },
    componentWillReceiveProps (np) {
      if (np.id !== this.props.id) this.props.get(np.id, false)
    }
  }),
  branch(({ data }) => isNull(data), renderComponent(NotFound))
)(StaticPage)



// WEBPACK FOOTER //
// ./src/containers/Checkout.jsx